import type { QueryHookOptions } from "@apollo/client"
import { useQuery } from "@apollo/client"
import query from "@/v2-backoffice-client/portfolio/portfolio.query.gql"
import type {
  PortfolioQuery,
  PortfolioQueryVariables,
} from "@/v2-backoffice-client/portfolio/__types__/portfolio.query"

type Options = QueryHookOptions<PortfolioQuery, PortfolioQueryVariables>

export function usePortfolioQuery(options?: Options) {
  return useQuery<PortfolioQuery, PortfolioQueryVariables>(query, options)
}
